<template>
    <div class="af3-shortcodes-single-map-component">
        <iframe
          v-if="baseSrc"
          id="af3-shortcodes-single-map-component-map-iframe"
          class="af3-shortcodes-single-map-component-map"
          :key="reloadKey"
          width="100%"
          height="100%"
          :src="computedSrc"
          frameborder="0"
          allow="geolocation"
        ></iframe>
        <div v-else class="af3-shortcodes-single-map-component-map" v-html="options.single_floor_plan_map_code"></div>
    </div>
</template>
  
<script>

import { defineComponent, ref, watch, computed } from 'vue';


export default defineComponent({
    components: { },
   
    props: { 
      options: {
        type: Object,
        required: true
      },
      floor_plan: { 
        type: Object,
        required: true
      },
      selected_unit_name: {
        type: String,
        required: false,
        default: null
      }
    },

    setup(props) {

        const baseSrc = computed(() => {
          const html = props.options?.single_floor_plan_map_code || '';
          const match = html.match(/src=["']([^"']+)["']/i);
          return match ? match[1] : '';
        });

        const computedSrc = computed(() => {
          if (!baseSrc.value) return '';
          const hasQuery = baseSrc.value.includes('?');
          const unit = props.selected_unit_name;
          // const unit = String(Math.floor(Math.random() * (213 - 201 + 1)) + 201);
    

          if (!unit || unit.length === 0) return baseSrc.value;
          const param = `${hasQuery ? '&' : '?'}unit_number=${encodeURIComponent(unit)}`;
          return `${baseSrc.value}${param}`;
        });

        const reloadKey = ref(0);
        watch([() => props.options?.single_floor_plan_map_code, () => props.selected_unit_name], () => {
          reloadKey.value += 1;
        });

        return {
          baseSrc,
          computedSrc,
          reloadKey
        };
  },


  
  
});
</script>